import Vue from "vue";
import Bearer from "./authbearer";
import URLPath from "../helpers/URL";

const Auth = require("@websanova/vue-auth");

const tokenName = process.env.VUE_APP_TOKEN_NAME;

Vue.use(Auth, {
  auth: Bearer,
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  tokenStore: ['cookie'],
  fetchData: {
    url: URLPath.SECURITY.ME.URI,
    method: URLPath.SECURITY.ME.METHOD,
    enabled: true
  },
  authRedirect: { path: '/login' },
  tokenDefaultName: tokenName,
  rolesVar: "role",
  loginData: {
    url: URLPath.SECURITY.LOGIN.URI,
    method: URLPath.SECURITY.LOGIN.METHOD,
    redirect: "/",
    fetchUser: true
  },
  logoutData: {
    url: URLPath.SECURITY.LOGOUT.URI,
    method: URLPath.SECURITY.LOGOUT.METHOD,
    redirect: "/login",
    makeRequest: true,
    transformRequest: function(data) {
      data = JSON.stringify({
        refresh_token: JSON.parse(Vue.auth.token(tokenName)).refresh_token
      });
      return data;
    }
  },
  refreshData: {
    url: URLPath.SECURITY.REFRESH.URI,
    method: URLPath.SECURITY.REFRESH.METHOD,
    enabled: true,
    transformRequest: function(data) {
      data = JSON.stringify({
        refresh_token: JSON.parse(Vue.auth.token(tokenName)).refresh_token
      });
      return data;
    }
  },
  parseUserData: data => data
});
